export const environment = {
  production: true,
  apiBaseUrl: '',
  azureAd: {
    clientId: '',
    tenentId: '',
    scopes: []
  },
  activeFeatures: '#{activeFeatures}#'
};
